var app = angular.module('app', [])

app.run(function () {
    $('.button').on('click', function (e) {
        if ($(this).data('confirm') && !confirm($(this).data('confirm'))) return false
        if ($(this).data('href')) window.location.href = $(this).data('href')
        if ($(this).data('back') !== undefined) window.history.back()
        if ($(this).attr('type') === 'submit') {
            $(this).attr('disabled', true)
            $(this).closest('form').submit()
        }
    })

    $('.toggle').on('click', function (e) {
        $('body').toggleClass('menuvisible')
    })

    $('.section.interactive h2').on('click', function (e) {
        $(this).parent().toggleClass('visible')
    })

    if ($('.dateformatter').length) {
        new Cleave('.dateformatter', {
            date: true,
            delimiter: '-',
            datePattern: ['d', 'm', 'Y'],
        })
    }

    if (!localStorage.getItem('cookie')) {
        $('.consent').addClass('visible')
    }

    $('.consent button').on('click', function (e) {
        $('.consent').removeClass('visible')
        localStorage.setItem('cookie', 1)
    })
})
